export default __webpack_public_path__ + "static/media/ttd_ketut_sadiana.70fb188d.png";